import { createContext, useContext, useState, useEffect } from "react";
import prodSalidas from "../data/prod_salidas.json";

export const ProdContext = createContext();

export const useProd = () => {
  const context = useContext(ProdContext);
  if (!context) {
    throw new Error("useProd debe usarse dentro de un ProdContextProvider");
  }
  return context;
};

export const ProdContextProvider = ({ children }) => {
  
  const [registros, setRegistros] = useState([]);
  const [registrosEntradas, setRegistrosEntradas] = useState([]);
  const [regIngresos, setRegIngresos] = useState([]);
  const [regDespachos, setRegDespachos] = useState([]);

  const [detalleVisible, setDetalleVisible] = useState(null);
  const [detalleVisibleEntrada, setDetalleVisibleEntrada] = useState("");
  const [detalleVisibleIng, setDetalleVisibleIng] = useState(null);
  const [detalleVisibleDesp, setDetalleVisibleDesp] = useState("");

  const productos = prodSalidas;


  const [cargado, setCargado] = useState(false);


  const agregarRegistro = (entrada) => {
    setRegistros((prev) => [...prev, entrada]);
  };

  const agregarEntrada = (entrada) => {
    setRegistrosEntradas((prev) => [...prev, entrada]);
  };

  const agregarRegIng = (entrada) => {
    setRegIngresos((prev) => [...prev, entrada]);
  };

  const agregarRegDesp = (entrada) => {
    setRegDespachos((prev) => [...prev, entrada]);
  };

  
  const setSalidasTotales = (nuevos) => setRegistros(nuevos);
  const setEntradasTotales = (nuevos) => setRegistrosEntradas(nuevos);
  const setIngresosTotales = (nuevos) => setRegIngresos(nuevos);
  const setDespachosTotales = (nuevos) => setRegDespachos(nuevos);


  const toggleDetalle = (productoId) => {
    setDetalleVisible((prev) => (prev === productoId ? null : productoId));
  };

  const toggleDetalleEntrada = (productoNombre) => {
    setDetalleVisibleEntrada((prev) =>
      prev === productoNombre ? "" : productoNombre
    );
  };

  const toggleDetalleIng = (productoId) => {
    setDetalleVisibleIng((prev) => (prev === productoId ? null : productoId));
  };

  const toggleDetalleDesp = (cliente) => {
    setDetalleVisibleDesp((prev) => (prev === cliente ? "" : cliente));
  };

 
  useEffect(() => {
    const dataGuardada = JSON.parse(localStorage.getItem("misRegistros"));
    if (dataGuardada) {
      setRegistros(dataGuardada.registros || []);
      setRegistrosEntradas(dataGuardada.registrosEntradas || []);
      setRegIngresos(dataGuardada.regIngresos || []);
      setRegDespachos(dataGuardada.regDespachos || []);
    }
    setCargado(true); 
  }, []);

  
  const guardarLocalStorage = () => {
    if (!cargado) return;
    const datos = {
      registros,
      registrosEntradas,
      regIngresos,
      regDespachos,
    };
    localStorage.setItem("misRegistros", JSON.stringify(datos));
  };

  useEffect(guardarLocalStorage, [registros]);
  useEffect(guardarLocalStorage, [registrosEntradas]);
  useEffect(guardarLocalStorage, [regIngresos]);
  useEffect(guardarLocalStorage, [regDespachos]);

  return (
    <ProdContext.Provider
      value={{
        registros,
        registrosEntradas,
        regIngresos,
        regDespachos,
        detalleVisible,
        detalleVisibleEntrada,
        detalleVisibleIng,
        detalleVisibleDesp,
        productos,
        agregarRegistro,
        agregarEntrada,
        agregarRegIng,
        agregarRegDesp,
        setSalidasTotales,
        setEntradasTotales,
        setIngresosTotales,
        setDespachosTotales,
        toggleDetalle,
        toggleDetalleEntrada,
        toggleDetalleIng,
        toggleDetalleDesp,
      }}
    >
      {children}
    </ProdContext.Provider>
  );
};
